// Auxiliary function for checking if a given item is in a given array
export function isInArray(val, arr) {
    for (let i = 0; i < arr.length; i++) {
        if (val === arr[i]) {
            return true;
        }
    }

    return false;
}